import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z M22.7247 25H11.0607V22.096H15.5727V10.864H15.3567L11.9487 15.328L9.64469 13.528L13.6527 8.248H19.1727V22.096H22.7247V25Z",
		fill: "currentColor"
	})
});
export default Svg1;
